import { useEffect } from 'react';
import './App.css';
import AppRouter from './routes';
import { LOCAL_STORAGE_KEYS } from './constants/storage';
import { ClientConfig } from './libs/r2-service-client';
import LoadingSpinner from './components/loading/LoadingSpinner';

export const AVAILABLE_LANGUAGES = ['ko', 'en'];
const App = () => {
  useEffect(() => {
    const token = localStorage.getItem(LOCAL_STORAGE_KEYS.ACCESS_TOKEN);
    const url = import.meta.env.VITE_FILE_API_BASE_URL;
    if (token) {
      ClientConfig.instance.setToken(token);
    }

    // 토큰 유무와 상관없이, 설정된 엔드포인트를 사용하도록 함
    ClientConfig.instance.setResourceEndpoint(url);
  }, []);

  return (
    <>
      <AppRouter />
      <LoadingSpinner />
    </>
  );
};

export default App;
